import { mapActions, mapGetters } from "vuex";
import {} from "@/store/action-types";

import listItem from "./list-item/index.vue";

export default {
    name: "active-order",
    data() {
        return {};
    },
    head: {
        title: function() {
            return {
                inner: "Точка ",
                separator: "|",
                complement: "Активні замовлення",
            };
        },
    },
    components: {
        "list-item": listItem,
    },
    computed: {
        ...mapGetters({
            activeOrderList: "profile/activeOrderList",
            activeOrderListLength: "profile/activeOrderListLength",
            activeOrderListLoading: "profile/activeOrderListLoading",
        }),
    },
    created() {
        // this.fetchActiveOrderList();
    },
    methods: {
        ...mapActions({
            fetchActiveOrderList: `profile/GET_ACTIVE_ORDER_LIST`,
        }),
    },
};
